<template>
    <div class="konfiguratorItem__image">
        <div class="js-gallery">
            <a v-for="(image, index) in images" :key="index" :href="image.big" class="gallery__link" :class="{'hidden' : index > 3}">
                <img class="img-fluid" :src="image.preview" :alt="image.alt">
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TypeImageGallery",
        props: {
            typeId: {},
            images: {}
        },
        computed: {
            loadImages() {
                var images = [];
                var typeImages = this.$store.getters.typeImages(this.typeId);
                typeImages.forEach(function (item, index) {
                    //if(index === 0) {
                    //    images.push({
                    //        preview: item.preview,
                    //        big: item.big
                    //    });
                    //} else if(index === 1) {
                    //    images[0].big = item.big;
                    //} else {
                    images.push({
                        preview: item.previewSmall,
                        big: item.big
                    });
                    //}
                });

                if (!images[0]) {
                    this.images = [];
                } else {
                    this.images = [images[0]];
                }

                return this.images;
            }
        }
    }
</script>

<style scoped>

</style>
